import React from 'react';
import { geoName } from '../format';

/* The market a term is polled in, as a flag with the country on hover. Every
 * geo we store is already ISO-3166-1 alpha-2, so the code maps straight onto a
 * flag-icons class; WORLDWIDE is the one value that is not a country. */

export default function Flag({ geo, size = 14 }) {
  const code = String(geo || '').toUpperCase();
  if (!code) return null;

  const name = geoName(code);

  if (code === 'WORLDWIDE') {
    return (
      <span className="tw-flag is-globe" style={{ fontSize: size }} title={name} role="img"
        aria-label={name}>
        &#127760;
      </span>
    );
  }

  return (
    <span
      className={`tw-flag fi fi-${code.toLowerCase()}`}
      style={{ width: size * 1.34, height: size }}
      title={name}
      role="img"
      aria-label={name}
    />
  );
}
